/**
 * 共通受付照会API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 機器単位詳細情報
 */
export interface Sgkb575aResDeviceUnitdetails {
    /** 
     * 受付連番：半角数字
     */
    aceptSerialnumber?: string;
    /** 
     * 小売機器連番：半角数字
     */
    retailequipmentserialnumber?: string;
    /** 
     * 小売機器型式番号：半角英数混在
     */
    retailequipmentModelnumber?: string;
    /** 
     * 小売機器製造番号：半角英数混在
     */
    retailequipmentManufacturingnumber?: string;
    /** 
     * 供給地点特定番号：半角英数混在
     */
    suppntSpno?: string;
    /** 
     * 小売機器取付取外コード：半角英数混在
     */
    retailequipmentInstallationremovalCode?: string;
    /** 
     * 小売機器取付取外コード名称：全角半角混在
     */
    retailequipmentInstallationremovalCodeaname?: string;
    /** 
     * 取付取外日付：日付YYYYMMDD
     */
    installationRemovalDate?: string;
    /** 
     * 小売機器取付位置コード：半角英数混在
     */
    retailequipmentInstallationlocationCode?: string;
    /** 
     * 小売機器取付位置コード名称：全角半角混在
     */
    retailequipmentInstallationlocationCodeaname?: string;
    /** 
     * 小売機器戸外ブザーフラグ：半角英数混在
     */
    retailequipmentOutdoorbuzzerFlg?: string;
    /** 
     * 小売機器戸外ブザーフラグ名称：全角半角混在
     */
    retailequipmentOutdoorbuzzerFlganame?: string;
    /** 
     * 小売機器メモ：全角文字
     */
    retailequipmentMemo?: string;
}
